export default {
	login: {
		keepSignedIn: 'Keep me signed in',
		forgotPassword: 'Forgot your password?',
		selectManagement: 'Select Management',
		select: 'Select',
		reset: {
			title: 'Change Password',
			changePasswordText:
				'Please enter your desired password in the field below ' +
				'and confirm it in the second field. The password strength indicator will ' +
				'show you how secure your chosen password is.',
			usernameEmail: '@:common.usernameEmail',
			currentPassword: 'Current Password',
			newPassword: 'New Password',
			confirmNewPassword: 'Confirm New Password',
		},
	},
}
